import React, { useState, useEffect, useRef } from 'react';
import styles from './LoanChooseBank.scss';
import ButtonRound from '../ButtonRound';
import { ILoanRequestChooseBank } from '../../utils/LoanRequest';
import { ILoanCalculatorTextKeys } from './LoanCalculatorPage';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { ILoanOffer } from '../../utils/BaufiSmartApi';
import Translate from '../../utils/Translate';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export interface ILoanChooseBankProps {
    uuid?: string;
    onNextStep: (data: any) => void;
    onPreviousStep: () => void;
    loanOffers: ILoanOffer[];
    // data: ILoanRequestChooseBank;
    // textKeys?: ILoanCalculatorTextKeys['step4'];
}

const LoanChooseBank: React.FC<React.PropsWithChildren<ILoanChooseBankProps>> = ({ loanOffers, onNextStep = () => {}, onPreviousStep = () => {} }) => {
    const [nrItems, setNrItems] = useState(3);

    const handleNextStep = (offer?: ILoanOffer) => {
        onNextStep({
            offer,
            // chooseBank: {
            //     banks: [offer],
            // },
        });
    };

    if (!loanOffers.length) {
        // API error, no banks found -> next step
        onNextStep({});
    }

    const handleShowFurther = () => {
        setNrItems(10);
    };

    return (
        <div className={styles.loanChooseBank}>
            <div>
                {loanOffers.slice(0, nrItems).map((offer, idx) => {
                    return <LoanChooseBankItem offer={offer} key={offer.bankName + idx} onNextStep={handleNextStep} />;
                })}

                <div className={styles.showMore}>
                    {loanOffers.length > nrItems && (
                        <a onClick={handleShowFurther}>
                            Weitere Finanzierungspartner <KeyboardArrowDownIcon />
                        </a>
                    )}
                </div>

                <div className={styles.actions}>
                    <ButtonRound onClick={onPreviousStep} variant="outlined" icon={<ChevronLeftIcon />} className={styles.back}>
                        zurück
                    </ButtonRound>

                    <ButtonRound
                        onClick={() => {
                            handleNextStep();
                        }}
                    >
                        Nächster Schritt
                    </ButtonRound>
                </div>
            </div>
        </div>
    );
};

const LoanChooseBankItem: React.FC<React.PropsWithChildren<{ offer: ILoanOffer; onNextStep: Function }>> = ({ offer, onNextStep }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={styles.box}>
            <h5>{offer.bankName}</h5>
            <div className={styles.teaser}>
                <div className={styles.logo}>
                    <img src={offer.bankLogo} />

                    <div className={styles.detailsAction}>
                        <a
                            onClick={() => {
                                setIsOpen(!isOpen);
                            }}
                            className={isOpen ? styles.open : ''}
                        >
                            Details <KeyboardArrowDownIcon />
                        </a>
                    </div>
                </div>
                <div className={styles.info}>
                    <dl>
                        <dd>{Translate.getNumber(offer.sollZins)}%</dd>
                        <dt>gebundener Sollzins</dt>
                    </dl>
                    <dl>
                        <dd>{Translate.getNumber(offer.effektivZins)}%</dd>
                        <dt>effektiver Jahreszins</dt>
                    </dl>
                    <dl>
                        <dd>{Translate.getPrice(offer.monatlicheRate)}</dd>
                        <dt>monatliche Rate</dt>
                    </dl>
                </div>

                <div className={styles.actions}>
                    <ButtonRound
                        // type=""
                        variant="outlined"
                        onClick={() => {
                            onNextStep(offer);
                        }}
                    >
                        Weiter
                    </ButtonRound>
                </div>
            </div>

            <div className={styles.details + ' ' + (isOpen ? styles.open : '')}>
                <dl>
                    <dt>Restschuld zum Ende der Sollzinsbindung:</dt>
                    <dd>{Translate.getPrice(offer.restSchuld)}</dd>
                </dl>
                <dl>
                    <dt>zu zahlender Gesamtbetrag:</dt>
                    <dd>{Translate.getPrice(offer.gesamtBetrag)}</dd>
                </dl>
                {offer.gesamtLaufzeit && (
                    <dl>
                        <dt>Laufzeit bis zur vollständigen Rückzahlung:</dt>
                        <dd>{Translate.getYearMonth(offer.gesamtLaufzeit)}</dd>
                    </dl>
                )}
            </div>
        </div>
    );
};

export default LoanChooseBank;
